export enum TransactionState {
    INITIATED = 'INITIATED',
    CREATED = 'CREATED',
    ATTEMPTED = 'ATTEMPTED',
    PAID = 'PAID',
  }
  